import { type FastAddDialogSettingsType } from 'app/main/modules/components/FastAddDialog';
import { InlineTitle } from 'app/main/modules/components/FastAddDialogSettingsManager';

import WebsitesDetailsSectionInfo from './sections/WebsitesDetailsSectionInfo';

const dialogSettings: FastAddDialogSettingsType = {
	content: props => (
		<>
			<InlineTitle text="DETAILS_INFO_SECTION" />
			<WebsitesDetailsSectionInfo {...props} />
		</>
	)
};

export default dialogSettings;
